<template>
  <div id="page-news-article-list-edit">
    <vs-alert
      color="danger"
      title="NewsArticleList Not Found"
      :active.sync="newsArticleList_not_found"
    >
      <span>
        Newsfeed record with id
        <strong>{{ $route.params.newsArticleListId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'news-article-list-list' }"
          class="text-inherit underline"
          >All Newsfeeds</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="localData">
      <dx-validation-group ref="validation-group">
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("NewsArticleList.Name") }}
            </div>
            <div class="dx-field-value">
              <DxTextBox :value.sync="localData.name">
                <DxValidator>
                  <DxRequiredRule
                    :message="$t('NewsArticleList.NameRequired')"
                  />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("NewsArticleList.Language") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="languages"
                :search-enabled="true"
                :value.sync="localData.language"
                display-expr="description"
                value-expr="id"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="$t('NewsArticleList.LanguageRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("NewsArticleList.Country") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="countries"
                :search-enabled="true"
                :value.sync="localData.country"
                display-expr="description"
                value-expr="id"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="$t('NewsArticleList.CountryRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("NewsArticleList.Kind") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="kinds"
                :search-enabled="true"
                :value.sync="localData.kind"
                display-expr="description"
                value-expr="id"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="$t('NewsArticleList.KindRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div v-show="localData.kind == 'HeadlinesByTopic'" class="dx-field">
            <div class="dx-field-label">
              {{ $t("NewsArticleList.Topic") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="topics"
                :search-enabled="true"
                :value.sync="localData.topic"
                display-expr="description"
                value-expr="id"
              >
                <!-- <DxValidator>
                  <DxRequiredRule
                    :message="$t('NewsArticleList.KindRequired')"
                  />
                </DxValidator> -->
              </DxSelectBox>
            </div>
          </div>
          <div v-show="localData.kind == 'Keywords'" class="vx-card">
            <!-- <div class="dx-field-label">
              {{ $t("NewsArticleList.Keywords") }}
            </div> -->
  
    
              <keyword-list-edit v-model="localData.keywords" />
        
          </div>
        </div>
      </dx-validation-group>
    </vx-card>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-4 mt-2" type="border" @click="preview">{{
            $t("NewsArticleList.Preview")
          }}</vs-button>
          <vs-button class="ml-auto mt-2" @click="saveChanges">{{
            $t("Save")
          }}</vs-button>
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="cancel"
            >{{ $t("Cancel") }}</vs-button
          >
        </div>
      </div>
    </div>
    <DxPopup
      content-template="popup-content"
      :visible.sync="showPreview"
      position="center"
      :title="$t('NewsArticleList.Preview')"
      :close-on-outside-click="true"
      :show-close-button="true"
    >
      <template #popup-content>
        <div>
          <dx-data-grid
            class="dx-card wide-card"
            :data-source="previewItems"
            :show-borders="true"
            :focused-row-enabled="false"
            :column-auto-width="false"
            :column-hiding-enabled="false"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
          >
            >
            <dx-paging
              :page-size="20"
              :show-page-size-selector="false"
              :show-info="true"
            />
            <dx-pager :show-page-size-selector="true" :show-info="true" />

            <dx-column
              data-field="title"
              :caption="$t('NewsArticleList.Preview.Title')"
              :hiding-priority="2"
              :visible="true"
              :width="800"
            />
            <dx-column
              data-field="url"
              :caption="$t('NewsArticleList.Preview.Url')"
              :hiding-priority="99"
            />
          </dx-data-grid>
        </div>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moduleNewsArticleListManagement from '@/store/news-article-list-management/moduleNewsArticleListManagement.js'
import KeywordListEdit from './KeywordListEdit'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxCheckBox } from 'devextreme-vue/check-box'
import { DxDateBox } from 'devextreme-vue/date-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxPopup } from 'devextreme-vue/popup'
import { notifyMixin } from '@/mixins/notifyMixin'
import DxDataGrid, {
  DxColumn,
  DxPager,
  DxPaging,
  DxPosition
} from 'devextreme-vue/data-grid'

export default {
  mixins: [notifyMixin],
  data () {
    return {
      newsArticleList_data: null,
      newsArticleList_not_found: false,
      localData: null,
      kinds: [],
      languages: [],
      countries: [],
      topics: [],
      showPreview: false,
      previewItems: []
    }
  },
  components: {
    DxSelectBox,
    DxTextBox,
    DxCheckBox,
    DxValidator,
    DxValidationGroup,
    DxRequiredRule,
    DxDateBox,
    KeywordListEdit,
    DxPopup,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxPosition
  },
  methods: {
    fetchData (newsArticleListId) {
      this.$store.dispatch('newsArticleListManagement/fetchNewsArticleList', newsArticleListId)
        .then(res => {
          console.dir(res.data.newsArticleList)

          let index = 0
          let keywords = []
          if (res.data.newsArticleList.parameters) {
            keywords = res.data.newsArticleList.parameters.map(a => {
              index++
              return { id: index, value: a.value, kind: a.kind, exactMatch: a.exactMatch }
            })
          }
          this.localData = { ...res.data.newsArticleList, keywords }
          this.localData.idOrganisation = this.activeOrganisation.id
          if (this.localData === null) {
            this.newsArticleList_not_found = true
          }
        })
        .catch(err => {
          if (!err.response) {
            console.dir(err)
            return
          }
          if (err.response.status === 404) {
            this.newsArticleList_not_found = true
            return
          }
          console.error(err)
        })
    },
    saveChanges () {
      if (!this.validateForm) return
      this.$vs.loading()
      this.$store.dispatch('newsArticleListManagement/saveNewsArticleList', this.getPostData())
        .then(() => {
          this.$router.push("/newsArticleList/list")
          this.$vs.loading.close()
          this.notifySuccess(this.localData.id ? this.$t('NewsArticleList.Updated') : this.$t('NewsArticleList.Created'))
        })
        .catch(error => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
    preview () {
      if (!this.validateForm) return
      this.$vs.loading()
      this.$store.dispatch('newsArticleListManagement/previewNewsArticleList', this.getPostData())
        .then((res) => {
          console.table(res.data.items)
          this.previewItems = res.data.items
          this.showPreview = true
          this.$vs.loading.close()
        })
        .catch(error => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
    getPostData () {
      const postParams = this.localData.keywords.map(a => {
        return { kind: a.kind, value: a.value, exactMatch: a.exactMatch }
      })
      const postData = { ...this.localData, parameters: postParams }
      return postData
    },
    cancel () {
      this.$router.push("/newsarticlelist/list")
    }
  },
  watch: {
    activeOrganisation: function (val) {

    },

  },
  computed: {
    ...mapGetters(["activeOrganisation"]),
    validateForm () {
      return !this.errors.any()
    }
  },
  created () {
    if (!moduleNewsArticleListManagement.isRegistered) {
      this.$store.registerModule('newsArticleListManagement', moduleNewsArticleListManagement)
      moduleNewsArticleListManagement.isRegistered = true
    }
    this.fetchData(this.$route.params.newsArticleListId)

    const kinds = [
      { id: "Headlines", text: 'Headlines' },
      { id: 'HeadlinesByTopic', text: 'HeadlinesByTopic' },
      { id: 'HeadlinesByLocation', text: 'HeadlinesByLocation' },
      { id: 'Keywords', text: 'Keywords' }]

    this.kinds = kinds.map(a => {
      return { id: a.id, description: this.$t(`NewsfeedKind.${a.text}`) }
    })

    const languages = [
      { id: "nl", text: 'Dutch' },
      { id: 'en', text: 'English' },
      { id: 'de', text: 'German' },
      { id: 'fr', text: 'French' },
      { id: 'es', text: 'Spanish' },
    ]

    this.languages = languages.map(a => {
      return { id: a.id, description: this.$t(`Language.${a.text}`) }
    })

    const countries = ['nl', 'gb', 'us', 'de', 'be', 'fr']

    this.countries = countries.map(a => {
      return { id: a, description: this.$t(`Country.${a}`) }
    })

    const topics = ["WORLD", "NATION", "BUSINESS", "TECHNOLOGY", "ENTERTAINMENT", "SCIENCE", "SPORTS", "HEALTH"]
    this.topics = topics.map(a => {
      return { id: a, description: this.$t(`Topic.${a}`) }
    })
  }
}

</script>
